import { render, staticRenderFns } from "./OrderTransactionTilledDetail.vue?vue&type=template&id=e2448112"
import script from "./OrderTransactionTilledDetail.vue?vue&type=script&lang=js"
export * from "./OrderTransactionTilledDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderTransactionTilledDetail.vue?vue&type=style&index=0&id=e2448112&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports